import type { Dimension } from './rows'

const TITLES: Record<Exclude<Dimension, 'stream'>, string> = {
  continent:   'Continents',
  country:     'Countries',
  region:      'Regions',
  studio:      'Studios',
  game:        'Games',
  brand:       'Brands',
  device_type: 'Device types',
  browser:     'Browsers',
  cdn_edge:    'CDN edges',
  user:        'Users',
}

type Props = {
  dimension: Dimension
  drillStream: string | null
  rowCount: number
  loading: boolean
  errored: boolean
  titleOverride?: string
}

export default function TableHeader({ dimension, drillStream, rowCount, loading, errored, titleOverride }: Props) {
  const title = titleOverride
    ?? (dimension === 'stream'
      ? (drillStream ? `Stream: ${drillStream}` : 'Streams')
      : TITLES[dimension])

  return (
    <div className="panel-head">
      <span className="panel-title">{title}</span>
      <span style={{ fontSize: 10, color: 'var(--t-2)' }}>{rowCount}</span>
      {loading && (
        <span style={{ fontSize: 10, color: 'var(--t-2)', marginLeft: 8 }}>Updating…</span>
      )}
      {errored && (
        <span style={{ fontSize: 10, color: 'var(--crit)', marginLeft: 8 }}>API error</span>
      )}
      <span style={{ marginLeft: 'auto', fontSize: 10, color: 'var(--t-2)' }}>
        Scroll to load more
      </span>
    </div>
  )
}
